import { Theme } from './types'
export * from './types'

const theme: Theme = {
  colors: {
    common: {
      black: '#000',
      white: '#fff',
    },
    primary: {
      100: '#EEEBFF',
      200: '#CDC5FF',
      300: '#1900AF',
      400: '#13007D',
      500: '#0A0A32',
      600: '#002A97',
      700: '#00227D',
      800: '#001B62',
      900: '#001447',
    },
    secondary: {
      100: '#FFEBEC',
      200: '#FFB0B5',
      300: '#FF646E',
      400: '#803237',
      500: '#4F1F22',
      600: '#CE6D6D',
      700: '#A95A5A',
      800: '#854646',
      900: '#613333',
    },
    tertiary: {
      100: '#FCE1EB',
      200: '#FFBEE6',
      300: '#FF78AA',
      400: '#803C55',
      500: '#592A3B',
    },
    success: {
      100: '#ECFFEB ',
      200: '#CBFFC8',
      300: '#098500',
      400: '#076600',
      500: '#055200',
      600: '#27B468',
      700: '#209455',
      800: '#197543',
      900: '#125531',
    },
    danger: {
      100: '#FFE6E5',
      200: '#FFCAC9',
      300: '#BD0700',
      400: '#9E0500',
      500: '#3D0201',
      600: '#D13636',
      700: '#AC2D2D',
      800: '#872323',
      900: '#621A1A',
    },
    warning: {
      100: '#FFFAE4 ',
      200: '#FFF5C5',
      300: '#BD9C00',
      400: '#695700',
      500: '#3D3300',
      600: '#D98A07',
      700: '#B37106',
      800: '#8C5904',
      900: '#664103',
    },
    info: {
      100: '#E3FCFF ',
      200: '#C3FFFF',
      300: '#00CDE6',
      400: '#005A66',
      500: '#00343B',
      600: '#0E85CD',
      700: '#0B6DA9',
      800: '#095685',
      900: '#063E60',
    },
    neutral: {
      100: '#E6E6F0',
      200: '#9292A9',
      300: '#555567',
      400: '#42424F',
      500: '#0A0A32',
      600: '#5F646F',
      700: '#4E535C',
      800: '#3E4148',
      900: '#2D2F34',
    },
    extra: {
      background: '#FFFFFA',
      disabled_bg: '#DADEE2',
      disabled_font: '#BDBCBC',
      gray_style: '#FAFAFC',
      gray_icon: '#90A0B7',
    },
  },
  shadows: [
    '0px 2px 6px rgba(0, 0, 0, 0.1)',
    '6px 6px 12px rgba(0, 0, 0, 0.08)',
    '0px 12px 18px rgba(0, 0, 0, 0.1)',
    '0px 10px 24px rgba(0, 0, 0, 0.1)',
  ],
  borderRadius: {
    none: '0px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    pill: '500px',
    circular: '50%',
  },
  borderWidths: {
    none: '0px',
    hairline: '1px',
    thin: '2px',
    thick: '4px',
    heavy: '8px',
  },
  spacing: value => value * 8,
  typography: {
    fontFamily: '"Nunito", sans-serif',
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeighSemiBold: 600,
    fontWeightBold: 700,
    fontWeightExtraBold: 800,
    fontWeightBlack: 900,
    h0: {
      fontFamily: '"Lato", "Nunito", sans-serif',
      fontSize: '48px',
      fontWeight: 900,
      letterSpacing: '0',
      lineHeight: '64px',
    },
    h1: {
      fontFamily: '"Lato", "Nunito", sans-serif',
      fontSize: '32px',
      fontWeight: 800,
      letterSpacing: '0',
      lineHeight: '48px',
    },
    h2: {
      fontFamily: '"Lato", "Nunito", sans-serif',
      fontSize: '24px',
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: '40px',
    },
    h3: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '20px',
      fontWeight: 700,
      letterSpacing: '0',
      lineHeight: '28px',
    },
    h4: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '18px',
      fontWeight: 600,
      letterSpacing: '0',
      lineHeight: '26px',
    },
    h5: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '16px',
      fontWeight: 600,
      letterSpacing: '0',
      lineHeight: '24px',
    },
    body1: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '16px',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: '24px',
    },
    body2: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: '22px',
    },
    button1: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '14px',
      fontWeight: 700,
      letterSpacing: '0.1rem',
      lineHeight: '24px',
    },
    button2: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '16px',
      fontWeight: 700,
      letterSpacing: '0.01rem',
      lineHeight: '24px',
    },
    button3: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '14px',
      fontWeight: 700,
      letterSpacing: '0.01rem',
      lineHeight: '24px',
    },
    link: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: '0.01rem',
      lineHeight: '24px',
    },
    label: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: '22px',
    },
    microCopy: {
      fontFamily: '"Nunito", sans-serif',
      fontSize: '12px',
      fontWeight: 400,
      letterSpacing: '0',
      lineHeight: '20px',
    },
  },
}

export { theme, Theme }
